<div class="site-container" [ngClass]="{'rtl': rtl}" [attr.dir]="rtl ? 'rtl' : null">
  <main class="main-content">
    <div class="main-content-wrap">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
